__turbopack_context__.v({
  "card": "UGCHighlightCard-module__WbWoqG__card",
  "cardDate": "UGCHighlightCard-module__WbWoqG__cardDate",
  "cardFooter": "UGCHighlightCard-module__WbWoqG__cardFooter",
  "cardSubtitle": "UGCHighlightCard-module__WbWoqG__cardSubtitle",
  "cardTag": "UGCHighlightCard-module__WbWoqG__cardTag",
  "contentHeader": "UGCHighlightCard-module__WbWoqG__contentHeader",
  "contentWrapper": "UGCHighlightCard-module__WbWoqG__contentWrapper",
  "description": "UGCHighlightCard-module__WbWoqG__description",
  "descriptionWrapper": "UGCHighlightCard-module__WbWoqG__descriptionWrapper",
  "image": "UGCHighlightCard-module__WbWoqG__image",
  "imagePlaceholder": "UGCHighlightCard-module__WbWoqG__imagePlaceholder",
  "imagePlaceholderWrapper": "UGCHighlightCard-module__WbWoqG__imagePlaceholderWrapper",
  "imageWrapper": "UGCHighlightCard-module__WbWoqG__imageWrapper",
  "quotationMark": "UGCHighlightCard-module__WbWoqG__quotationMark",
  "seeImagesButton": "UGCHighlightCard-module__WbWoqG__seeImagesButton",
});
